import React, { Component } from "react";
import "./FeedbackUser.css";
import Page from "../2/Controls/Page";
import PageSection from "../2/Controls/PageSection";
import Input from "../2/Controls/Input";
import Button from "../2/Controls/Button";
import Icon from "../2/Controls/Icon";
import NewButton from "../2/Controls/NewButton";

class FeedbackUser extends Component {
  constructor(props) {
    super(props);

    this.state = {
      loading: false,
      formData: null,
      responses: {},
      errors: {},
      submitted: false,
      currentStep: 1,
      totalSteps: 1,
      showErrors: false,
      isInitializing: true,
      isSubmitting: false,
      errormessage:"",
    };
  }

 componentDidMount() {
  const id = this.props.match.params.id;
  
  if (id) {
    this.setState({ isInitializing: true, loading: true });
    
    this.props.getFeedbackByTemplateId(id)
      .then((response) => {
        if(response.code=="0"){
          this.setState({ 
            formData: response.data, // Changed from 'feedback' to 'response.data'
            loading: false,
            isInitializing: false,
            errormessage:""
          }, () => {
            this.initializeResponses();
          });
        }
        else{
          this.setState({
            formData: null, // Changed from 'feedback' to 'null'
            loading: false,
            isInitializing: false,
            errormessage:response.message
          })
        }
      })
      .catch((error) => {
        console.error("Error fetching feedback:", error);
        this.setState({ 
          loading: false, 
          isInitializing: false 
        });
      });
  } else {
    console.error("No ID provided in params");
    this.setState({ 
      loading: false, 
      isInitializing: false 
    });
  }
}
  initializeResponses = () => {
    const { formData } = this.state;
    if (formData && formData.Questions) {
      const initialResponses = {};
      formData.Questions.forEach((question, index) => {
        if (question.AnswerType === "checkbox") {
          initialResponses[index] = [];
        } else if (question.AnswerType === "star") {
          initialResponses[index] = 0;
        } else {
          initialResponses[index] = "";
        }
      });
      this.setState({ responses: initialResponses });
    }
  };

  validateEmail = (email) => {
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return emailRegex.test(email);
  };

  validatePhone = (phone) => {
    const phoneRegex = /^[0-9]{10}$/;
    return phoneRegex.test(phone);
  };

  validateField = (questionIndex, value, question) => {
    const error = {};

    if (question.Mandatory) {
      if (question.AnswerType === "checkbox") {
        if (!value || value.length === 0) {
          error[questionIndex] = "This field is required";
          return error;
        }
      } else if (question.AnswerType === "star") {
        if (value === 0 || value === null || value === undefined) {
          error[questionIndex] = "Please provide a star rating";
          return error;
        }
      } else {
        if (!value || value.trim() === "") {
          error[questionIndex] = "This field is required";
          return error;
        }
      }
    }

    if (question.AnswerType === "email" && value && value.trim() !== "") {
      if (!this.validateEmail(value)) {
        error[questionIndex] = "Please enter a valid email address";
        return error;
      }
    }

    if (question.AnswerType === "phone" && value && value.trim() !== "") {
      if (!this.validatePhone(value)) {
        error[questionIndex] = "Please enter a valid 10-digit phone number";
        return error;
      }
    }

    return error;
  };

  validateAllFields = () => {
    const { formData, responses } = this.state;
    const errors = {};
    let hasErrors = false;

    if (!formData || !formData.Questions) {
      return { errors, hasErrors: true };
    }

    formData.Questions.forEach((question, index) => {
      const value = responses[index] || "";
      const fieldError = this.validateField(index, value, question);
      if (Object.keys(fieldError).length > 0) {
        errors[index] = fieldError[index];
        hasErrors = true;
      }
    });

    return { errors, hasErrors };
  };

  handleInputChange = (questionIndex, value, question) => {
    if (value && typeof value === 'object' && value.target) {
      value = value.target.value;
    }
    
    const { responses, errors } = this.state;

    const updatedResponses = {
      ...responses,
      [questionIndex]: value,
    };

    const updatedErrors = { ...errors };
    delete updatedErrors[questionIndex];

    this.setState({
      responses: updatedResponses,
      errors: updatedErrors,
    });
  };

  handleResponseChange = (questionIndex, value, question) => {
    if (value && typeof value === 'object' && value.target) {
      value = value.target.value;
    }
    
    const { responses, errors } = this.state;

    const updatedResponses = {
      ...responses,
      [questionIndex]: value,
    };

    const updatedErrors = { ...errors };
    delete updatedErrors[questionIndex];

    this.setState({
      responses: updatedResponses,
      errors: updatedErrors,
    });
  };

  handleCheckboxChange = (questionIndex, optionValue, checked, question) => {
    const { responses, errors } = this.state;
    const currentValues = responses[questionIndex] || [];
    let updatedValues;

    if (checked) {
      updatedValues = [...currentValues, optionValue];
    } else {
      updatedValues = currentValues.filter(v => v !== optionValue);
    }

    const updatedResponses = {
      ...responses,
      [questionIndex]: updatedValues,
    };

    const updatedErrors = { ...errors };
    delete updatedErrors[questionIndex];

    this.setState({
      responses: updatedResponses,
      errors: updatedErrors,
    });
  };

  handleStarRating = (questionIndex, rating) => {
    const { responses, errors } = this.state;
    
    const updatedResponses = {
      ...responses,
      [questionIndex]: rating,
    };

    const updatedErrors = { ...errors };
    delete updatedErrors[questionIndex];

    this.setState({
      responses: updatedResponses,
      errors: updatedErrors,
    });
  };

handleSubmit = async () => {
  const { errors, hasErrors } = this.validateAllFields();
  
  if (hasErrors) {
    this.setState({ 
      errors, 
      showErrors: true,
      submitted: false 
    });
    const firstErrorIndex = Object.keys(errors)[0];
    if (firstErrorIndex) {
      const errorElement = document.getElementById(`question-${firstErrorIndex}`);
      if (errorElement) {
        errorElement.scrollIntoView({ behavior: 'smooth', block: 'center' });
      }
    }
    return;
  }

  this.setState({ isSubmitting: true, loading: true });
  
  try {
    // Format data to match MongoDB schema
    const { formData, responses } = this.state;
    
    // Build the Answers array from responses
    const answersArray = formData.Questions.map((question, index) => {
      let answerValue = responses[index];
      
      // Convert checkbox arrays to comma-separated string or handle as needed
      if (question.AnswerType === "checkbox" && Array.isArray(answerValue)) {
        answerValue = answerValue.join(", ");
      }
      
      return {
        QuestionID: question.id,
        Answer: answerValue !== undefined && answerValue !== null ? answerValue : "",
        AnswerType: question.AnswerType || ""
      };
    });

    const submissionData = {
      FeedbackTemplateID: formData.key,
      FeedbackLinkID: this.props.match.params.id, // Using the ID from URL params
      Answers: answersArray,
    };

    // Make API call with formatted data
    const response = await this.props.saveFeedbackResponse(submissionData);
    
    if (response.code === "0") {
      this.setState({ 
        submitted: true, 
        loading: false,
        showErrors: false,
        isSubmitting: false
      });
    } else {
      alert("Please try again. Failed to save feedback!");
      this.setState({ 
        loading: false, 
        isSubmitting: false 
      });
    }
  } catch (error) {
    console.error("Submission error:", error);
    this.setState({ 
      loading: false, 
      isSubmitting: false,
      errormessage: error.message || "Failed to submit feedback. Please try again."
    });
    // Optionally show error to user
    alert(error.message || "Failed to submit feedback. Please try again.");
  }
};
  renderQuestion = (question, index) => {
    const { responses, errors, showErrors } = this.state;
    const value = responses[index] || "";
    const error = errors[index];
    const showError = showErrors && error;

    const renderInputByType = () => {
      switch (question.AnswerType) {
        case "text":
          return (
            <Input
              type="text"
              placeholder="Enter your answer..."
              value={value}
              onChange={(e) => this.handleResponseChange(index, e, question)}
              error={showError ? error : ""}
              isMandatory={question.Mandatory}
            />
          );

        case "textarea":
          return (
            <Input
              type="textarea"
              placeholder="Enter your answer..."
              value={value}
              onChange={(e) => this.handleResponseChange(index, e, question)}
              error={showError ? error : ""}
              isMandatory={question.Mandatory}
            />
          );

        case "email":
          return (
            <Input
              type="emailid"
              placeholder="Enter your email..."
              value={value}
              onChange={(e) => this.handleResponseChange(index, e, question)}
              error={showError ? error : ""}
              isMandatory={question.Mandatory}
            />
          );

        case "phone":
          return (
            <Input
              type="mobileno"
              placeholder="Enter 10-digit phone number..."
              value={value}
              onChange={(e) => this.handleResponseChange(index, e, question)}
              error={showError ? error : ""}
              isMandatory={question.Mandatory}
              maxLength="10"
            />
          );

        case "dropdown":
          return (
            <div className="user-dropdown-container">
              <select
                className={`user-select ${showError ? 'error' : ''}`}
                value={value}
                onChange={(e) => this.handleResponseChange(index, e.target.value, question)}
              >
                <option value="">Select an option...</option>
                {question.Options && question.Options.map((option, optIndex) => (
                  <option key={optIndex} value={option.value || option.label}>
                    {option.label}
                  </option>
                ))}
              </select>
              {showError && <div className="user-error-message">{error}</div>}
            </div>
          );

        case "radio":
          return (
            <div className="user-radio-group">
              {question.Options && question.Options.map((option, optIndex) => (
                <label key={optIndex} className="user-radio-option">
                  <input
                    type="radio"
                    name={`question-${index}`}
                    value={option.value || option.label}
                    checked={value === (option.value || option.label)}
                    onChange={(e) => this.handleResponseChange(index, e.target.value, question)}
                  />
                  <span className="user-radio-label">{option.label}</span>
                </label>
              ))}
              {showError && <div className="user-error-message">{error}</div>}
            </div>
          );

        case "checkbox":
          return (
            <div className="user-checkbox-group">
              {question.Options && question.Options.map((option, optIndex) => {
                const isChecked = (responses[index] || []).includes(option.value || option.label);
                return (
                  <label key={optIndex} className="user-checkbox-option">
                    <input
                      type="checkbox"
                      checked={isChecked}
                      onChange={(e) => this.handleCheckboxChange(
                        index, 
                        option.value || option.label, 
                        e.target.checked,
                        question
                      )}
                    />
                    <span className="user-checkbox-label">{option.label}</span>
                  </label>
                );
              })}
              {showError && <div className="user-error-message">{error}</div>}
            </div>
          );

        case "emoji":
          return (
            <div className="user-emoji-group">
              {question.Options && question.Options.map((option, optIndex) => (
                <button
                  key={optIndex}
                  className={`user-emoji-option ${value === (option.value || option.label) ? 'selected' : ''}`}
                  onClick={() => this.handleResponseChange(index, option.value || option.label, question)}
                >
                  <span className="user-emoji-icon">{option.label}</span>
                </button>
              ))}
              {showError && <div className="user-error-message">{error}</div>}
            </div>
          );

        case "star":
          const rating = value || 0;
          const starCount = question.starCount || 5;
          return (
            <div className="user-star-rating">
              <div className="user-stars">
                {[...Array(starCount)].map((_, i) => {
                  const starValue = i + 1;
                  return (
                    <span
                      key={i}
                      className={`user-star ${starValue <= rating ? 'filled' : 'empty'}`}
                      onClick={() => this.handleStarRating(index, starValue)}
                    >
                      {starValue <= rating ? '⭐' : '☆'}
                    </span>
                  );
                })}
                {rating > 0 && <span className="user-rating-text">{rating} / {starCount}</span>}
              </div>
              {showError && <div className="user-error-message">{error}</div>}
            </div>
          );

        default:
          return (
            <Input
              type="text"
              placeholder="Enter your answer..."
              value={value}
              onChange={(e) => this.handleResponseChange(index, e, question)}
              error={showError ? error : ""}
              isMandatory={question.Mandatory}
            />
          );
      }
    };

    return (
      <div 
        key={index} 
        id={`question-${index}`}
        className={`user-question-container ${showError ? 'has-error' : ''}`}
      >
        <div className="user-question-header">
          <span className="user-question-text">{question.Question}</span>
          {question.Mandatory && <span className="user-mandatory-star">*</span>}
        </div>
        <div className="user-question-input">
          {renderInputByType()}
        </div>
      </div>
    );
  };

  renderHeader = () => {
    const { formData } = this.state;
    if (!formData || !formData.Header) return null;

    const { Header } = formData;
    const headerStyle = {
      backgroundColor: Header.BackgroundColor || "#FFFFFF",
      color: Header.TextColor || "#000000",
    };

    return (
      <>
      {Header.ShowHeader &&<div className="user-header-fixed" style={headerStyle}>
        <div className="user-header-content">
          {Header.Image && Header.Image.Url && (
            <div className="user-header-image">
              <img 
                src={Header.Image.Url} 
                alt="Header" 
                className="user-header-img"
              />
            </div>
          )}
          {Header.Text && (
            <div className="user-header-text">
              <h1>{Header.Text}</h1>
            </div>
          )}
        </div>
      </div>}
      </>
    );
  };

  renderFooter = () => {
    const { formData } = this.state;
    if (!formData || !formData.Footer) return null;

    const { Footer } = formData;
    const footerStyle = {
      backgroundColor: Footer.BackgroundColor || "#FFFFFF",
      color: Footer.TextColor || "#000000",
    };

    return (<>
     {Footer.ShowFooter && <div className="user-footer-fixed" style={footerStyle}>
        <div className="user-footer-content">
          {Footer.Image && Footer.Image.Url && (
            <div className="user-footer-image">
              <img 
                src={Footer.Image.Url} 
                alt="Footer" 
                className="user-footer-img"
              />
            </div>
          )}
          {Footer.Text && (
            <div className="user-footer-text">
              <p>{Footer.Text}</p>
            </div>
          )}
        </div>
      </div>}
      </>
    );
  };

  renderSubmitButton = () => {
    const { isSubmitting } = this.state;

    return (
      <div className="user-submit-container">
        <div className="user-submit-wrapper">
          <NewButton
            type="primary"
            text={isSubmitting ? "Submitting..." : "Submit Feedback"}
            onClick={this.handleSubmit}
            disabled={isSubmitting}
            className="user-submit-btn"
          />
        </div>
      </div>
    );
  };

renderSuccess = () => {
  return (
    <div className="user-success-container">
      <div className="user-success-icon-wrapper">
        <div className="user-success-icon-circle">
          <span className="user-checkmark"></span>
        </div>
      </div>
      <h2>Thank You!</h2>
      <p>Your feedback has been submitted successfully.</p>
      <NewButton
        type="primary"
        text="Submit Another Response"
        onClick={() => {
          this.setState({ 
            submitted: false,
            responses: {},
            errors: {},
            showErrors: false 
          });
          this.initializeResponses();
        }}
      />
    </div>
  );
};

  renderLoading = () => {
    return (
      <div className="user-loading-overlay">
        <div className="user-loading-container">
          <div className="user-loading-spinner"></div>
          <p>Loading feedback form...</p>
        </div>
      </div>
    );
  };

  render() {
    const { formData, loading, submitted, isInitializing } = this.state;

    if (isInitializing || loading) {
      return this.renderLoading();
    }

    if (!formData) {
      return (
        <div className="user-error-container">
          <p>{this.state.errormessage || "No form data available. Please check the URL and try again."}</p>
        </div>
      );
    }

    if (submitted) {
      return this.renderSuccess();
    }

    return (
      <div className="user-feedback-wrapper">
        {this.renderHeader()}
        
        <div className="user-feedback-content">
          <div className="user-feedback-container">
            {formData.Description && (
              <div className="user-description">
                <p>{formData.Description}</p>
              </div>
            )}

            <div className="user-questions-list">
              {formData.Questions && formData.Questions.map((question, index) => 
                this.renderQuestion(question, index)
              )}
            </div>
          </div>
        </div>

        {this.renderSubmitButton()}
        
        {this.renderFooter()}
      </div>
    );
  }
}

export default FeedbackUser;